function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import { rem } from 'polished';
import React from 'react';
import Box from '../Box';
const FilterIcon = _ref => {
  let {
    size = 16,
    bg = 'currentColor',
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement(Box, _extends({
    as: "svg",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: rem(size),
    height: rem(size),
    fill: bg,
    verticalAlign: "middle"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M22.9 2.6c-.2-.4-.5-.6-.9-.6H2c-.4 0-.7.2-.9.6-.2.3-.1.7.1 1L9 12.8V19c0 .4.2.7.6.9l4 2c.1.1.2.1.4.1s.4 0 .5-.1c.3-.2.5-.5.5-.9v-8.2l7.8-9.2c.2-.3.3-.7.1-1zm-9.7 9.2c-.1.2-.2.4-.2.7v6.9l-2-1v-5.9c0-.2-.1-.5-.2-.6L4.2 4h15.7l-6.7 7.8z"
  }));
};
export default FilterIcon;